/**
 * @namespace v3sWbtPlayerApp:exercise:listbox
 */
/**
 * @class directive_v3sListbox
 * @memberOf v3sWbtPlayerApp:exercise:listbox
 * @description
 * Die Listbox Direktive
 * - Es können mehrere Antworten richtig sein!
 */
angular.module('v3sWbtPlayerApp').directive('v3sListbox', ["v3sListboxElement", "$tooltip", "v3sI18nService", function (v3sListboxElement, $tooltip, v3sI18nService) {
    return {
        restrict: 'E',
        scope : {
            id: '@',
            v3sWidth: '@'
        },
        require: '^v3sDocument',
        transclude: true,
        templateUrl: "app/js/exercise/listbox/listbox.tpl.html",
        link: function (scope, element, attrs, v3sDocumentCtrl, transclude) {
            element.css('height', 'auto');

            var tooltip, fod;
            var listboxElement = new v3sListboxElement(scope.id);

            scope.getVar = v3sDocumentCtrl.getVar;
            if (!!scope.id) {
                v3sDocumentCtrl.addElement(element);
            }

            var hasUserAnswer = listboxElement.getUserAnswer();
            if (hasUserAnswer !== "") {
                scope.selected = hasUserAnswer;
            }
            scope.items = [];
            transclude(scope, function (clone, scope) {
                angular.forEach(clone, function (node, index) {
                    var tagName = node.tagName.toLowerCase();
                    var innerText = node.textContent;
                    if (!!innerText) {
                        if (tagName == "v3s-item") {
                            scope.items.push({ id: index, label: innerText, styleClass: '' });
                            listboxElement.addItem({ id: index, "correct": node.getAttribute("v3s-correct") });
                        } else if (tagName == "v3s-fod") {
                            fod = innerText;
                        }
                    }
                });
            });


            scope.$watch('selected', function (newAnswer, oldAnswer) {
                if (!listboxElement.completed && !element.hasClass('correct')) {//If no Answer is given yet
                    if (newAnswer !== oldAnswer && newAnswer >= 0) {
                        listboxElement.setUserAnswer(newAnswer);
                    }
                } else if (newAnswer !== listboxElement.getUserAnswer()) {//Exercise is already done
                    scope.selected = listboxElement.getUserAnswer();
                }
            });

            listboxElement.setShowFeedback(function () {
                if (listboxElement.isFeedbackVisible()) {
                    var status = listboxElement.getStatus();
                    var msg = v3sI18nService.getText([
                        "exercises.fod.listbox." + status.name,
                        "exercises.fod.general." + status.name
                    ]);

                    if (!!tooltip) {
                        tooltip.hide();
                        tooltip.setEnabled(false);
                        element.removeClass('wrong');
                    }

                    if (status == listboxElement.STATUS.FALSE || status == listboxElement.STATUS.NO_ANSWER) {
                        element.addClass('wrong');
                    } else {
                        element.addClass('correct');
                    }

                    if (listboxElement.completed) {
                        angular.forEach(scope.items, function (item, index) {
                            item.styleClass = (listboxElement.isCorrect(index)) ? 'correct' : 'wrong';
                        })

                        if (!!fod) {
                            msg += " " + fod;
                        }
                    }

                    tooltip = $tooltip(element.find("button"), { title: msg, container: "v3s-document", viewport: '#page-view', placement: 'top auto' });
                }
            });
        }
    }
}]);
